/* sf-card-sport.js — CRD-01 Sportkarte: Klappen (24.09.2026)
   Gemeinsam fuer die Library (?view=sfui, CRD-01) und sections/sf-marquee-cards.liquid.
   Markup: snippets/sf-card-sport.liquid. Styles: assets/sf-card-sport.css.

   - Rechner (Maus): Zeigen klappt um, Wegziehen klappt zurueck.
   - Telefon (Touch, Stift): Tippen auf die Karte oder "+" klappt um, "x" zurueck.
   - Kanon: Oeffnet eine Karte, schliessen die anderen derselben Reihe.
   - Tastatur: Enter/Leertaste auf "+" oeffnet und setzt den Fokus auf die
     Rueckseite, Esc oder "x" schliesst und setzt ihn zurueck auf "+".
   - Die verdeckte Seite ist jeweils inert + aria-hidden.
   Ereignisse sind an document delegiert: Karten, die der Theme-Editor neu
   rendert, funktionieren ohne erneute Initialisierung. */
(function () {
  if (window.__sfCardSport) return;
  window.__sfCardSport = true;
  document.documentElement.classList.add('sf-card-sport-js');

  var CARD = '[data-sf-card-sport]';

  function part(card, name) { return card.querySelector('[data-sf-card-sport-' + name + ']'); }
  function isOpen(card) { return card.classList.contains('is-open'); }
  function conceal(el, hidden) {
    if (!el) return;
    if (hidden) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); }
    else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
  }
  /* Langer Text: data-overflow="top|bottom" nur, wenn der Textbereich
     wirklich scrollt; die CSS-Maske laesst den Text dort weich auslaufen. */
  function flagOverflow(body) {
    if (!body) return;
    var max = body.scrollHeight - body.clientHeight;
    if (max <= 1) { body.removeAttribute('data-overflow'); return; }
    var v = [];
    if (body.scrollTop > 1) v.push('top');
    if (body.scrollTop < max - 1) v.push('bottom');
    body.setAttribute('data-overflow', v.join(' '));
  }
  function focusQuiet(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function close(card, returnFocus) {
    if (!isOpen(card)) return;
    var back = part(card, 'back');
    var hadFocus = back && back.contains(document.activeElement);
    card.classList.remove('is-open');
    card.removeAttribute('data-sf-open-mode');
    var body = part(card, 'body');
    if (body) { body.scrollTop = 0; body.removeAttribute('data-overflow'); }
    conceal(back, true);
    conceal(part(card, 'face'), false);
    var btn = part(card, 'open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (returnFocus || hadFocus) focusQuiet(btn);
  }

  function open(card, mode, focusBack) {
    var row = card.parentElement;
    if (row) {
      var others = row.querySelectorAll(CARD + '.is-open');
      for (var i = 0; i < others.length; i++) if (others[i] !== card) close(others[i], false);
    }
    var body = part(card, 'body');
    if (isOpen(card)) { if (focusBack) focusQuiet(body); return; }
    var face = part(card, 'face');
    var hadFocus = face && face.contains(document.activeElement);
    card.classList.add('is-open');
    card.setAttribute('data-sf-open-mode', mode);
    conceal(face, true);
    conceal(part(card, 'back'), false);
    var btn = part(card, 'open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    flagOverflow(body);
    if (focusBack || hadFocus) focusQuiet(body);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest(CARD);
    if (!card) return;
    if (t.closest('[data-sf-card-sport-close]')) { close(card, true); return; }
    if (t.closest('[data-sf-card-sport-open]')) { open(card, 'pin', true); return; }
    if (!isOpen(card)) open(card, 'pin', false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var t = e.target;
    var card = t && t.closest ? t.closest(CARD) : null;
    if (card && isOpen(card)) close(card, true);
  });

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var card = e.target.closest(CARD);
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    if (!isOpen(card)) open(card, 'hover', false);
  });

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-sf-card-sport-body') && t.closest(CARD + '.is-open')) flagOverflow(t);
  }, true);

  window.addEventListener('resize', function () {
    var bodies = document.querySelectorAll(CARD + '.is-open [data-sf-card-sport-body]');
    for (var i = 0; i < bodies.length; i++) flagOverflow(bodies[i]);
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var card = e.target.closest(CARD);
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    if (isOpen(card) && card.getAttribute('data-sf-open-mode') === 'hover') close(card, false);
  });
})();
